import { PageTemplate } from "@/components/Templates/PageTemplate";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useScopeParams } from "@/hooks/useScopeParams";
import { FEATURE_FLAGS } from "@/utils/feature-flag-constants";

export default function InvestigatorDirectory() {
  const { buildUrl } = useScopeParams();
  const profileHidden = useFeatureFlag(
    FEATURE_FLAGS.INVESTIGATOR_PROFILE_LINKS_HIDDEN,
  );

  return (
    <PageTemplate
      title="Portfolio: Investigators"
      tooltipText="Cross-trial investigator profiles showing performance across the portfolio."
      type="portfolio-investigators"
      selectionIdentifierColumn="inv_key"
      constants={{
        wikiLink: "/wiki/guides/portfolio-investigators",
        idLink: profileHidden
          ? undefined
          : (invKey: string) => buildUrl(`investigators/${invKey}`),
      }}
    />
  );
}
